module.exports = __webpack_public_path__ + "img/note-img1.c402255c.png";